import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SuperAdminService } from '../../../services/super-admin.service';
import { HttpService } from '../../../services/http.service';
import { HttpClient } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-user-report',
  templateUrl: './user-report.component.html',
  styleUrls: ['./user-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UserReportComponent implements OnInit {
  types = ['ROLE_ADDITION', 'ROLE_DELETION'];
  userRoleStatusForm: FormGroup;
  loginAuditControl = new FormControl('');
  loadingExport = false;
  reportGenerateInProgress = false;
  auditReportGenerateInProgress = false;
  crmxCustomerGenerateInProgress = false;
  constructor(
    private cdRef: ChangeDetectorRef,
    private superAdminService: SuperAdminService,
    private httpService: HttpService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.bindUserRoleStatusForm();
    this.loginAuditControl.valueChanges.pipe(debounceTime(100)).subscribe(() => {});

    this.userRoleStatusForm.valueChanges.pipe(debounceTime(100)).subscribe(() => {});
  }

  async loadingUserRoleDataData() {
    try {
      this.reportGenerateInProgress = true;
      let filterData = this.userRoleStatusForm.value;
      this.downloadReport(
        `/admin/user-role-status/export?roleName=${filterData?.roleName || ''}&type=${filterData?.type || ''}&addedByText=${
          filterData?.addedByText || ''
        }&addedToText=${filterData?.addedToText || ''}`
      );
      this.reportGenerateInProgress = false;
    } catch (e) {
      this.reportGenerateInProgress = false;
      console.log(e);
    }
  }

  async loadingUserLoginAudit() {
    try {
      this.auditReportGenerateInProgress = true;
      this.downloadReport(`/admin/user-login-audit/export?searchText=${this.loginAuditControl.value || ''}`);
      this.auditReportGenerateInProgress = false;
    } catch (e) {
      this.auditReportGenerateInProgress = false;
      console.log(e);
    }
  }

  async loadingCustomerCrmx() {
    try {
      this.crmxCustomerGenerateInProgress = true;
      this.cdRef.detectChanges();
      this.downloadReport(`/admin/customer-crm-audit/export`);
      this.crmxCustomerGenerateInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.crmxCustomerGenerateInProgress = false;
      this.cdRef.detectChanges();
      console.log(e);
    }
  }

  get(url: string, data?: any) {
    let formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    return this.http.get(formattedUrl, { responseType: 'blob' }).toPromise();
  }

  downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
    this.cdRef.detectChanges();
  };

  downloadReport(url) {
    this.cdRef.detectChanges();
    let link = document.createElement('a');
    link.href = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    link.dispatchEvent(new MouseEvent('click'));
    this.reportGenerateInProgress = false;
    this.cdRef.detectChanges();
  }

  bindUserRoleStatusForm() {
    this.userRoleStatusForm = new FormGroup({
      roleName: new FormControl(''),
      addedByText: new FormControl(''),
      addedToText: new FormControl(''),
      type: new FormControl(''),
    });
  }
}
